module.exports = __webpack_public_path__ + "img/background-watermark_cn.6a7d591.jpg";